module.exports = __webpack_public_path__ + "img/0bdbe0d524bd4da2ac5213cb4d378ef8.png";